import { AppUserMenuPageAttribute } from '@/api/models';

export type PageReadability = 'full' | 'readonly' | 'limitedView';

export interface ITourPageSettings {
  driver: PageReadability;
  fairway: PageReadability;
  hybrid: PageReadability;
  utility: PageReadability;
  iron: PageReadability;
  wedge: PageReadability;
  putter: PageReadability;
  bsg: PageReadability;
  playerBio: PageReadability;
}

const pageNameToKeyMap: Record<string, keyof ITourPageSettings> = {
  TourBagDriver: 'driver',
  TourBagFairway: 'fairway',
  TourBagHybrid: 'hybrid',
  TourBagUtility: 'utility', // will copy iron later
  TourBagIron: 'iron',
  TourBagWedge: 'wedge',
  TourBagPutter: 'putter',
  TourBagBsg: 'bsg',
  TourBagPlayerBio: 'playerBio',
};

export const getTourPageSettings = (userPageAttributes: AppUserMenuPageAttribute[]): ITourPageSettings => {
  // Default: all pages full access
  const pageSettings: ITourPageSettings = Object.keys(pageNameToKeyMap).reduce((acc, pageName) => {
    acc[pageNameToKeyMap[pageName]] = 'full';
    return acc;
  }, {} as ITourPageSettings);

  userPageAttributes.forEach((attr) => {
    const key = pageNameToKeyMap[attr.appPageName];
    if (!key) return;

    // Map attribute to readability
    if (attr.appAttributeName === 'ReadOnly') pageSettings[key] = 'readonly';
    if (attr.appAttributeName === 'LimitedView') pageSettings[key] = 'limitedView';
  });

  // Copy iron permission to utility
  pageSettings.utility = pageSettings.iron;

  return pageSettings;
};
